// theme.js — single source of truth for all design tokens
// Import this wherever you need colours, fonts, spacing or breakpoints

export const colors = {
  // Background gradient (used on every page wrapper)
  bgGradient: 'linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)',
  bgDark1: '#0f0c29',
  bgDark2: '#302b63',
  bgDark3: '#24243e',

  // Primary accent
  primary: '#667eea',
  primaryDark: '#764ba2',
  primaryGradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',

  // Header
  headerBg: 'linear-gradient(135deg, #1a202c 0%, #2d3748 100%)',

  // Footer
  footerBg: '#0d0d0d',
  footerText: '#bbb',
  footerBorder: '#1e1e1e',

  // Status colours
  success: '#4CAF50',
  error: '#ef4444',
  errorDark: '#c62828',
  warning: '#f97316',

  // Text on dark backgrounds
  textWhite: 'rgba(255, 255, 255, 0.95)',
  textWhiteMuted: 'rgba(255, 255, 255, 0.7)',
  textWhiteFaint: 'rgba(255, 255, 255, 0.5)',

  // Text on light backgrounds
  textDark: '#1a202c',
  textMedium: '#374151',
  textMuted: '#6b7280',
  textLight: '#94a3b8',

  // Light surface (cards, tables)
  surface: '#ffffff',
  surfaceAlt: '#f9fafb',
  borderLight: '#e5e7eb',
  borderLighter: '#f3f4f6',

  // Glass / dark panel
  glassBg: 'rgba(0, 0, 0, 0.22)',
  glassBorder: 'rgba(255, 255, 255, 0.12)',
  glassHover: 'rgba(255, 255, 255, 0.08)',

  // Scrollbar
  scrollThumb: '#667eea',
  scrollThumbHover: '#764ba2',
  scrollTrack: '#f1f1f1',
};

export const fonts = {
  family: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",

  // Heading sizes (desktop)
  h1: '3em',
  h2: '1.8em',
  h3: '1.3em',
  h4: '1.1em',

  // Heading sizes (mobile)
  h1Mobile: '2em',
  h2Mobile: '1.4em',
  h3Mobile: '1.1em',

  // Body
  bodyLg: '1.1em',
  body: '1em',
  bodySm: '0.9em',
  bodyXs: '0.85em',

  // Small / labels
  label: '0.8em',
  labelSm: '0.75em',
  tiny: '0.7em',

  // Weights
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

export const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  wide: '1600px',
};

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px',
  xxxl: '80px',

  // Page-level
  pageTopDesktop: '100px',
  pageTopMobile: '80px',
  pageSideDesktop: '40px',
  pageSideMobile: '16px',
};

export const radius = {
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '16px',
  xxl: '20px',
  pill: '25px',
  circle: '50%',
};

export const shadows = {
  sm: '0 2px 8px rgba(0, 0, 0, 0.1)',
  md: '0 4px 20px rgba(0, 0, 0, 0.08)',
  lg: '0 8px 32px rgba(0, 0, 0, 0.12)',
  xl: '0 12px 48px rgba(0, 0, 0, 0.15)',
  cardHover: '0 12px 24px rgba(0, 0, 0, 0.15)',
  primaryGlow: '0 4px 12px rgba(102, 126, 234, 0.3)',
  primaryGlowLg: '0 8px 24px rgba(102, 126, 234, 0.4)',
  error: '0 4px 20px rgba(239, 68, 68, 0.1)',
};

export const transitions = {
  fast: 'all 0.15s ease',
  base: 'all 0.2s ease',
  slow: 'all 0.3s ease',
};
